import React, { Component } from "react";
import { connect } from "react-redux";
import moment from 'moment';
import { Grid, Col, Row, Button, ControlLabel } from "react-bootstrap";
import JqxGrid, { jqx } from "jqwidgets-scripts/jqwidgets-react-tsx/jqxgrid";
import "jqwidgets-scripts/jqwidgets/styles/jqx.material.css";
import DatePicker from 'react-date-picker';
import Card from "../../../components/Card/Card";
import { dominio } from "../../../routes_backend/routes";
import { PDFReporte } from "../../../components/utils/Pdf_produccion.js";
import _ from "lodash";
import Loading from "../../../views/Loading";
import "./style.css";
import Swal from 'sweetalert2';  // Importa SweetAlert2


const cellClassName = (row, columnfield, value, rowData) => {
  console.log(rowData.U_EstatusFactura);
  
  if (rowData.U_EstatusFactura === "Revisado") {
    return 'red-row';
  }
  if (rowData.U_EstatusFactura === "Facturado") {
    return 'green-row';
  }
  return '';
};


// const myGrid = React.createRef();
export class CtrlCombustibleExtFacturacion extends Component {
  constructor(props) {
    super(props);


    this.state = {


      from_Date: new Date(),
      to_Date: new Date(),
      message: "",
      isLoading: false,
      source_grid: "",
      source_gridUnidades: "",
      dataGraphic: '',



      columns: [
        { text: "Documento", datafield: "DocNum", width: '5%', pinned: 'true', cellsalign: "center", align: "center", editable: false, cellclassname: cellClassName },
        { text: "Vale", datafield: "U_NoVale", width: '4%', pinned: 'true', cellsalign: "center", align: "center", editable: false, cellclassname: cellClassName  },
        { text: "Fecha", datafield: "FechaDespachoF", width: '5%', cellsalign: "center", align: "center", editable: false, cellclassname: cellClassName  },
        { text: "Unidad", datafield: "U_Unidad", width: '4%', cellsalign: "center", align: "center", editable: false, cellclassname: cellClassName  },
        { text: "Gls", datafield: "U_Galones", width: '4%', cellsalign: "center", cellsformat: 'f2', align: "center", editable: false, cellclassname: cellClassName  },
        { text: "Piloto", datafield: "U_Piloto", width: '13%', cellsalign: "center", align: "center", editable: false, cellclassname: cellClassName  },
        { text: "Descripcion", datafield: "U_Descripcion", width: '7%', cellsalign: "center", align: "center", editable: false, cellclassname: cellClassName  },
        { text: "Comentario", datafield: "Comments", width: '10%', cellsalign: "center", align: "center", editable: false, cellclassname: cellClassName  },
        { text: "Origen", datafield: "U_Origen", width: '5%', cellsalign: "center", align: "center", editable: false, cellclassname: cellClassName  },
        { text: "Destino", datafield: "U_Destino", width: '5%', cellsalign: "center", align: "center", editable: false, cellclassname: cellClassName  },
        { text: "Cartelera", datafield: "Cartelera", width: '5%', cellsalign: "center", cellsformat: 'f2', align: "center", /*editable: false,*/ cellclassname: cellClassName  },
        { text: "Cobro", datafield: "Cobro", width: '5%', cellsalign: "center", cellsformat: 'f2', align: "center", editable: false, cellclassname: cellClassName  },
        { text: "Total", datafield: "Total", width: '5%', cellsalign: "center", cellsformat: 'f2', align: "center", editable: false, cellclassname: cellClassName  },
        { text: "Status",
          datafield: "U_EstatusFactura",
          width: '6%',
          cellsalign: "center",
          align: "center",
          columntype: 'dropdownlist',  cellclassname: cellClassName, 
          createeditor: function (row, cellvalue, editor) {
            editor.jqxDropDownList({
              source: ["Revisado", "Facturado"], // Opciones del combo lista
              autoDropDownHeight: true // Ajusta la altura del dropdown
            });
          },
          cellvaluechanging: function (row, column, columntype, oldvalue, newvalue) {
            if (newvalue !== oldvalue) {
              console.log(`El valor cambió de ${oldvalue} a ${newvalue}`);
            }
          }
        },
        { text: "Fecha",
          datafield: "U_FechaFacturacion",
          width: '7%',
          cellsalign: "center",
          align: "center",
          columntype: 'datetimeinput',
          cellsformat: 'dd/MM/yyyy', cellclassname: cellClassName ,
          createeditor: function (row, cellvalue, editor) {
            if (!cellvalue) {
              editor.jqxDateTimeInput('setDate', new Date());
            }
          }
        },
        { text: "#Factura", datafield: "U_NoFactura", width: '5%', cellsalign: "center", align: "center", cellclassname: cellClassName },

        {
          datafield: "Crear", align: "center", width: "5%", editable: true, columntype: "button", /*cellclassname: "special",*/  cellclassname: cellClassName, 
          buttonclick: (row) => {
            const dataRecord = this.gridRef.current.getrowdata(row);
            var docentry, cartelera, cobro, total, fechaFact, noFact, status;
            docentry = dataRecord.DocEntry;
            cartelera = dataRecord.Cartelera;
            cobro = dataRecord.Cobro;
            total = dataRecord.Total;
            fechaFact = dataRecord.U_FechaFacturacion;
            noFact = dataRecord.U_NoFactura;
            status = dataRecord.U_EstatusFactura;




            this.updateBtn(docentry, cartelera, cobro, total, fechaFact, noFact, status);


          },
          cellsrenderer: function () {
            return "Actualizar";
          }
        },




      ],

    };
    this.gridRef = React.createRef(); // Define el ref
    this.onCellEndEdit = this.onCellEndEdit.bind(this);
  }


  onCellEndEdit(event) {
    const { args } = event;
    const { datafield, rowindex, value } = args;

    if (datafield === "Cartelera") {
      const grid = this.gridRef.current;
      const rowData = grid.getrowdata(rowindex); // Accede a los datos de la fila

      if (!rowData) return; // Asegúrate de que la fila exista

      const galones = parseFloat(rowData.U_Galones || 0);
      const cobro = parseFloat(value) - 0.50;
      const total = galones * cobro;

      // Actualizar los valores en las columnas Cobro y Total
      grid.setcellvalue(rowindex, "Cobro", cobro.toFixed(2));
      grid.setcellvalue(rowindex, "Total", total.toFixed(2));
    }
  }


  onChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,

    });
  };
  onChangeFromDate(date) {
    this.setState({ from_Date: date });
  }
  onChangeToDate(date) {
    this.setState({ to_Date: date });
  }


  clear = () => {
    this.setState({

      message: "",
      isLoading: false,
      source_grid: "",
      from_Date: new Date(),
      to_Date: new Date(),
    });
  };



  // data = (event) => {
  //   this.data()
  //   this.dataUnidades()
  // };

  data = () => {
    const { from_Date, to_Date } = this.state;
    let username = "";
    let password = "";

    let token = localStorage.getItem("token");
    let token_Data = JSON.parse(token);
    if (token_Data !== null) {
      token_Data.forEach((element) => {
        username = element.usuarioSAP;
        password = element.contraseñaSAP;
      });
    }

    if (token_Data === null) {
      this.props.history.push("");
    }

    let from = moment(from_Date).format('YYYYMMDD');
    let to = moment(to_Date).format('YYYYMMDD');

    this.setState({
      isLoading: true,
    });

    fetch(`${dominio}/get_ValesDespachadosFacturacion`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        username,
        password,
        from,
        to
      }),
    })



      .then(async (res) => {
        let data = await res.json();
        console.log(data);

        const temp_res = Object.entries(data).length === 0; // true
        if (temp_res === true) {
          return this.setState({
            message: "no data",
            source_grid: "",
            isLoading: false,
          });
        }
        let array_source = [];
        data.forEach((element) => {
          let array = {
            DocEntry: element.DocEntry,
            DocNum: element.DocNum,
            U_NoVale: element.U_NoVale,
            U_FechaDespacho: element.U_FechaDespacho,
            FechaDespachoF: element.FechaDespachoF,
            U_Unidad: element.U_Unidad,
            U_Galones: element.U_Galones,
            U_Piloto: element.U_Piloto,
            U_Descripcion: element.U_Descripcion,
            Comments: element.Comments,
            U_Origen: element.U_Origen,
            U_Destino: element.U_Destino,
            Cartelera: element.Cartelera,
            Cobro: element.Cobro,
            Total: element.Total,
            U_FechaFacturacion: element.U_FechaFacturacion,
            U_NoFactura: element.U_NoFactura,
            U_EstatusFactura: element.U_EstatusFactura,
          };

          array_source.push(array);
        });

        let temp_grid = {
          data: [],
          localdata: array_source,
          datafields: [
            { name: "DocEntry", type: "string" },
            { name: "DocNum", type: "string" },
            { name: "U_NoVale", type: "string" },
            { name: "U_FechaDespacho", type: "string" },
            { name: "FechaDespachoF", type: "string" },
            { name: "U_Unidad", type: "string" },
            { name: "U_Galones", type: "number" },
            { name: "U_Piloto", type: "string" },
            { name: "U_Descripcion", type: "string" },
            { name: "Comments", type: "string" },
            { name: "U_Origen", type: "string" },
            { name: "U_Destino", type: "string" },
            { name: "Cartelera", type: "number", },
            { name: "Cobro", type: "number" },
            { name: "Total", type: "number" },
            { name: "U_EstatusFactura", type: "string" },
            { name: "U_FechaFacturacion", type: "date" },
            { name: "U_NoFactura", type: "number" }

          ],
          datatype: "json",
        };

        this.setState({
          data: temp_grid,
          isLoading: false,
          source_grid: new jqx.dataAdapter(temp_grid),
          message: "",
        });
      })
      .catch((error) => {
        this.setState({
          isLoading: false,
          message: "No hay carteleras actualizadas",
        });
      });
  };



  updateBtn = (docentry, cartelera, cobro, total, fechaFact, noFact, status) => {
    let username = "";
    let password = "";
    let token = localStorage.getItem("token");
    let token_Data = JSON.parse(token);

    if (token_Data) {
      const user = token_Data[0];
      username = user.usuarioSAP;
      password = user.contraseñaSAP;
    } else {
      this.props.history.push(""); // Redirige si no hay token
      return;
    }

    this.setState({ isLoading: true });

    fetch(`${dominio}/CtrlCombuExtFacturacion`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username, password, docentry, cartelera, cobro, total, fechaFact, noFact, status }),
    })
      .then((res) => res.json())
      .then((data) => {
        this.setState({ isLoading: false });

        if (data.success) {
          Swal.fire({
            icon: "success",
            title: "Éxito",
            text: "Dato actualizado exitosamente",
          }).then(() => this.data()); // Actualizar datos
        } else {
          const errorMessage = data.message || "Ocurrió un error al procesar la solicitud.";
          Swal.fire({
            icon: "error",
            title: "Error",
            text: errorMessage, // Muestra el mensaje detallado del backend
          });
        }
      })
      .catch((error) => {
        this.setState({ isLoading: false });
        const errorMessage = error.message || "No se pudo conectar al servidor.";
        Swal.fire({
          icon: "error",
          title: "Error de red",
          text: errorMessage,
        });
      });
  };



  render() {
    const { message, isLoading, from_Date, to_Date } = this.state;


    return (
      <div
        className="content"
        style={{ textAlign: "center", alignItems: "center" }}
      >

        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title="Control de Desapacho Diesel Facturacion"
                category=""
                ctTableFullWidth
                ctTableResponsive
                content={
                  <div className="row">
                    <div>
                      <div className="row">
                        <div className="col-sm-2">
                          <ControlLabel>Del: </ControlLabel>
                          <br />
                          <DatePicker
                            onChange={(from_Date) => this.onChangeFromDate(from_Date)}
                            value={from_Date}
                          />
                        </div>
                        <div className="col-sm-2">
                          <ControlLabel>Al: </ControlLabel>
                          <br />
                          <DatePicker
                            onChange={(to_Date) => this.onChangeToDate(to_Date)}
                            value={to_Date}
                          />
                        </div>

                        {/*  */}





                        <div className="col-sm-3">
                          <br />
                          <Button
                            onClick={this.data}
                            bsStyle="primary"
                            bsSize="small"
                            active
                          >
                            Search
                          </Button>
                          &nbsp;
                          <Button
                            onClick={this.clear}
                            bsStyle="danger"
                            bsSize="small"
                            active
                          >
                            Clear
                          </Button>
                          <p style={style.errorMessage}>{message}</p>
                        </div>
                      </div>
                      <br />
                      <br />
                      <br />
                      <br />
                      <br />
                      <br />

                      {!_.isEmpty(this.state.source_grid) ? (
                        <div className="col-sm-12">

                          <br />
                          <br />
                          <div className="col-sm-12">
                            <div className="col-sm-12">
                              <p style={{ fontWeight: "bold", color: "red", fontSize: "30px" }}>
                                Actualizar Status Facturacion Externos
                              </p>
                              <br />
                              <br />
                              <JqxGrid
                                ref={this.gridRef}
                                width={"100%"}
                                // height={"600px"}
                                autoheight={true}
                                columns={this.state.columns}
                                source={this.state.source_grid}
                                theme={"material"}
                                editable={true}
                                filterable={true}
                                selectionmode={"singlerow"}
                                showfilterrow={true}
                                altrows={true}
                                enabletooltips={true}
                                columnsresize={true}
                                showtoolbar={true}
                                sortable={true}
                                showstatusbar={true}
                                showaggregates={true}
                                onCellendedit={this.onCellEndEdit}
                                
                              />

                            </div>
                          </div>



                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                }
              />
            </Col>
          </Row>
        </Grid>
        {isLoading && <Loading />}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {};
}
export default connect(mapStateToProps, { PDFReporte })(
  CtrlCombustibleExtFacturacion
);
const style = {
  text: {
    textAlign: "center",
  },

  errorMessage: {
    fontWeight: "bold",
    fontSize: "12px",
    height: "10px",
    color: "red",
  },
};
